import { createSvgIcon } from '@mui/material';

const IconLandscape = createSvgIcon(
  <path d="M2.99999 18C2.58332 18 2.28332 17.8167 2.09999 17.45C1.91666 17.0833 1.94999 16.7333 2.19999 16.4L6.19999 11.075C6.39999 10.8083 6.66666 10.675 6.99999 10.675C7.33332 10.675 7.59999 10.8083 7.79999 11.075L11.5 16H19L14 9.34999L11.5 12.65L10.25 11L13.2 7.07499C13.4 6.80832 13.6667 6.67499 14 6.67499C14.3333 6.67499 14.6 6.80832 14.8 7.07499L21.8 16.4C22.05 16.7333 22.0833 17.0833 21.9 17.45C21.7167 17.8167 21.4167 18 21 18H2.99999ZM4.99999 16H8.99999L6.99999 13.325L4.99999 16Z" />,
  'landscape'
);

export default IconLandscape;
